"use client";

import { MainLink, TitleH3 } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const Hero = () => {
  const t = useTranslations("home");

  return (
    <div className="from-background to-primary h-[500px] bg-gradient-to-t">
      <div className="gs--page-column flex flex-col items-center gap-7 pt-15 text-center">
        <TitleH3 title={t("hero.title")} className="text-white" />

        <p className="text-white lg:w-1/2">{t("hero.text")}</p>
        <MainLink href={"/grundriss-designs"} title={t("hero.linkTitle")} />
      </div>
    </div>
  );
};

export default Hero;
